import { render, staticRenderFns } from "./LanguagesAddNewPopup.vue?vue&type=template&id=3f2b804d&scoped=true&"
import script from "./LanguagesAddNewPopup.vue?vue&type=script&lang=js&"
export * from "./LanguagesAddNewPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2b804d",
  null
  
)

export default component.exports